import instance from "../api-provider";

export const categoryList = async (token) => {
  try {
    let response = await instance({
      url: "/smsSrvc/categoryList",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

export const techSupport = async (payload, token) => {
  try {
    let response = await instance({
      url: "/smsSrvc/techSupport",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};
